const subcategories = [
  { icon: 'ri-temp-cold-line', label: 'HVAC' },
  { icon: 'ri-drop-line', label: 'Plumbing' },
  { icon: 'ri-home-4-line', label: 'Roofing' },
  { icon: 'ri-flashlight-line', label: 'Electrical' },
  { icon: 'ri-hammer-line', label: 'General Contractors' },
];

const painPoints = [
  'Missed inbound calls during peak hours',
  'Poor scheduling coordination between office and field',
  'Technicians underbooked due to no-shows and gaps',
  'No consistent follow-up on sent estimates',
];

const solutions = [
  'AI answers every call—even after hours',
  'Real-time calendar booking with auto-dispatch',
  'Route optimization keeps techs fully scheduled',
  'Automated follow-up sequences close more estimates',
];

export default function HomeServicesSection() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block bg-amber-100 text-amber-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-5">
              Home Services
            </span>
            <h2 className="text-4xl font-extrabold text-[#0F172A] mb-5 leading-tight">
              Home Service Businesses
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              Designed for contractors who rely on fast response times and
              efficient scheduling. When a pipe bursts or an AC fails, customers
              call the first business that picks up. Omega Solutions AI makes
              sure that&apos;s always you.
            </p>

            <div className="flex flex-wrap gap-3 mb-10">
              {subcategories.map((cat) => (
                <div
                  key={cat.label}
                  className="flex items-center gap-2 bg-slate-100 rounded-full px-4 py-2"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-blue-600 text-sm`} />
                  </div>
                  <span className="text-[#0F172A] text-sm font-medium">{cat.label}</span>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-red-50 rounded-2xl p-6 border border-red-100">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-error-warning-line text-red-500 text-sm" />
                  </div>
                  <p className="text-red-700 text-sm font-bold uppercase tracking-wide">Pain Points</p>
                </div>
                <ul className="space-y-2">
                  {painPoints.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-slate-600">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-close-line text-red-400 text-sm" />
                      </div>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-green-50 rounded-2xl p-6 border border-green-100">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-check-double-line text-green-600 text-sm" />
                  </div>
                  <p className="text-green-700 text-sm font-bold uppercase tracking-wide">Our Solution</p>
                </div>
                <ul className="space-y-2">
                  {solutions.map((s) => (
                    <li key={s} className="flex items-start gap-2 text-sm text-slate-600">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-green-500 text-sm" />
                      </div>
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border border-slate-100" style={{ height: '480px' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/050afe0e136c6aa402c1145c418c07dd.jpg"
              alt="Home service contractor HVAC technician field work"
              title="Home Service Business Automation"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
